<div class="leads-details-pr">
  <div class="info-section">
    <h2 class="section-title">Informações do Lead</h2>
    <div class="section-divider"></div>

    <app-info-field [data]="leadInfo['linha1'] || []" [columns]="8" />
    <div class="spacer" style="height: 2rem"></div>
    <app-info-field [data]="leadInfo['linha2'] || []" [columns]="8" />
    <div class="spacer" style="height: 2rem"></div>
    <app-info-field [data]="leadInfo['linha3'] || []" [columns]="8" />
  </div>

  <div class="info-section">
    <h2 class="section-title">Informações do Financiamento</h2>
    <div class="section-divider"></div>

    <app-info-field [data]="financingInfo['linha1'] || []" [columns]="8" />
    <div class="spacer" style="height: 4rem"></div>
    <app-info-field [data]="financingInfo['linha2'] || []" [columns]="8" />
    <div class="spacer" style="height: 4rem"></div>
    <app-info-field [data]="financingInfo['linha3'] || []" [columns]="8" />

    @if (showQuickApproval) {
      <div class="slider-wrapper">
        @if (sliderLoading) {
          <div class="loading-state">
            <div class="loading-spinner"></div>
            Consultando dados da Régua de Aprovação
          </div>
        }

        @if (!sliderLoading && reguaSegments.length > 0) {
          <div class="slider-section">
            <app-slider
              [value]="sliderValue"
              [segments]="reguaSegments"
              (valueChange)="sliderValueChange.emit($event)"
            />
          </div>
        }
      </div>
    }

    <div style="height: 2rem"></div>
  </div>

  <div class="new-simulation-button-container">
    <button class="nav-btn" (click)="navigate.emit(1)" appTrackClick trackEvent="detalhes_oferta"
      trackCategory="lead_details" trackLabel="button_navigation">
      Detalhes da Oferta
    </button>
    <button class="nav-btn" (click)="navigate.emit(2)" appTrackClick trackEvent="historico"
      trackCategory="lead_details" trackLabel="button_navigation">
      Histórico
    </button>
    <button class="new-simulation-button" (click)="generateSimulation.emit()" appTrackClick
      trackEvent="nova_simulacao" trackCategory="lead_details" trackLabel="generate_simulation">
      Gerar Nova Simulação
    </button>
  </div>
</div>
